import { render } from "./indexfour-banner.vue?vue&type=template&id=7e54e7bd"
import script from "./indexfour-banner.vue?vue&type=script&lang=js"
export * from "./indexfour-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__